import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center cursor-pointer">
              <img
                src="https://lunch4you.de/assets/logo_new-BUicn5Zg.png"
                alt="Lunch4You"
                className="h-14 w-auto transition-all duration-300"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#menu" className={`text-sm font-medium transition-colors cursor-pointer hover:text-primary-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Menu
            </a>
            <a href="#corporate" className={`text-sm font-medium transition-colors cursor-pointer hover:text-primary-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Corporate
            </a>
            <a href="#plans" className={`text-sm font-medium transition-colors cursor-pointer hover:text-primary-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Plans
            </a>
            <a href="#about" className={`text-sm font-medium transition-colors cursor-pointer hover:text-primary-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              About
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <button className={`px-5 py-2 text-sm font-medium transition-colors rounded-full whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-primary-500' : 'text-white hover:text-primary-200'}`}>
              Sign In
            </button>
            <button className="px-6 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Order Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-4 space-y-3">
            <a href="#menu" className="block py-2 text-gray-700 font-medium cursor-pointer hover:text-primary-500">
              Menu
            </a>
            <a href="#corporate" className="block py-2 text-gray-700 font-medium cursor-pointer hover:text-primary-500">
              Corporate
            </a>
            <a href="#plans" className="block py-2 text-gray-700 font-medium cursor-pointer hover:text-primary-500">
              Plans
            </a>
            <a href="#about" className="block py-2 text-gray-700 font-medium cursor-pointer hover:text-primary-500">
              About
            </a>
            <div className="pt-4 space-y-2">
              <button className="w-full px-5 py-2.5 text-gray-700 font-medium border border-gray-300 rounded-full hover:border-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Sign In
              </button>
              <button className="w-full px-6 py-2.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">
                Order Now
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}